import styled from "styled-components/macro";
import { Modal } from "react-bootstrap";

import "../styled.scss";

export const UpdateRosterStatusModalStyles = styled(Modal)`
  .modal-body {
    padding: 24px;
    height: calc(100vh - 200px);
    overflow: auto;

    .company-details-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      padding-bottom: 24px;
      border-bottom: 1px solid var(--Neutral-4);

      .brand-name {
        max-width: 168px;
        width: 100%;

        .logo-text {
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--Neutral-60);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: -0.012px;

          svg {
            width: 12px;
            height: 12px;
          }
        }

        .main-text {
          color: var(--Neutral-100);
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: -0.021px;
          width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .form-wrapper-styles {
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }

  .modal-footer {
    padding: 16px;
    height: 96px;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    border-top: 1px solid var(--Neutral-8);

    button {
      width: 100%;

      svg {
        width: 16px;
        height: 16px;
      }
    }

    .warning-text {
      color: var(--Neutral-100);
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.012px;
    }
  }
`;
